import { Form } from "react-bootstrap";

export default Form.Label;
